/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeAccordion, BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import {
  ContentDescription,
  ContentQuestions,
} from '../ffrequents-questions/style';
import {
  ContainerFaq,
  ContainerTitleFaq,
  TitleFaq,
} from './modal-ddetail-style';

function FaqDetail({
  options,
  title,
  color,
  setOptions,
  defaultvalues,
  handleClick,
  selectedId,
}) {
  return (
    <div style={{ width: '100%' }}>
      <ContainerFaq>
        <ContainerTitleFaq>
          <TitleFaq>{title}</TitleFaq>
        </ContainerTitleFaq>
        {options.map((question) => (
          <ContentQuestions key={question.id}>
            <BaSeAccordion
              backgroundContentColor={color}
              backgroundTitleColor={color}
              borderTitleColor={color}
              onOpenIndexChange={() => {
                if (question.opened) {
                  setOptions(defaultvalues);
                } else {
                  handleClick(question.id);
                }
              }}
              shadow="0"
              startOpen={question.opened ? 0 : undefined}
              options={[
                {
                  content: (
                    <ContentDescription>
                      <BaSeParagraph
                        color={
                          selectedId === 2
                            ? '#000'
                            : BaSeTheme.colors.defaultColors.white
                        }
                      >
                        {React.cloneElement(question.description(), {
                          key: question.id,
                        })}
                      </BaSeParagraph>
                    </ContentDescription>
                  ),
                  title: (
                    <BaSeParagraph
                      color={
                        selectedId === 2
                          ? '#000'
                          : BaSeTheme.colors.defaultColors.white
                      }
                    >
                      {question.title.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </BaSeParagraph>
                  ),
                },
              ]}
              radius={30}
              titleColor="#ffffff"
            />
          </ContentQuestions>
        ))}
      </ContainerFaq>
    </div>
  );
}

export default FaqDetail;
